<template>
  <div class="compressed-content">
    <h3 class="page-question">Do either of your biological parents have a history of diabetes?<br />(Check all that apply)</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.parentsDiabet">
      <b-form-checkbox v-model="survey.parentsDiabet.isMother" 
                       @change="onMotherSelected">
        <svg-icon name="mother" /> Mother
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.parentsDiabet.isFather" 
                       @change="onFatherSelected">
        <svg-icon name="father" /> Father
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.parentsDiabet.isDontKnow" 
                       @change="onDontKnowSelected">
        <svg-icon name="dk" /> Both
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.parentsDiabet.isNeither" 
                       @change="onNeitherSelected">
        <svg-icon name="like" /> Neither
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      parentsDiabet: {
        anyOptionRequired: anyOptionRequired((value) => value.isMother || value.isFather || value.isDontKnow
          || value.isNeither)
      }
    },

    computed: {
      ...mapState(["survey"]),

      parentsDiabet() { return this.survey.parentsDiabet }
    },

    methods: {
      onMotherSelected(value) {
        this.setOptions(value, this.survey.parentsDiabet.isFather, false, false);
      },

      onFatherSelected(value) {
        this.setOptions(this.survey.parentsDiabet.isMother, value, false, false);
      },

      onDontKnowSelected(value) {
        this.setOptions(false, false, value, false);
      },

      onNeitherSelected(value) {
        this.setOptions(false, false, false, value);
      },

      setOptions(isMother, isFather, isDontKnow, isNeither) {
        this.survey.parentsDiabet.isMother = isMother;
        this.survey.parentsDiabet.isFather = isFather;
        this.survey.parentsDiabet.isDontKnow = isDontKnow;
        this.survey.parentsDiabet.isNeither = isNeither;
      }
    }
  };
</script>